
<cst-folder-document-tree (dataSourceInit)="onDataSourceInit($event)" folderSource="contract" documentSource="infoportal" />